
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CashbackRules from "@/components/cashback/CashbackRules";
import AutomatedMessages from "@/components/cashback/AutomatedMessages";

const Cashback = () => {
  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-2xl font-bold">Cashback</h1>
        <p className="text-gray-500">Configure as regras do seu programa de cashback</p>
      </header>

      <Tabs defaultValue="rules">
        <TabsList className="grid w-full max-w-lg grid-cols-2">
          <TabsTrigger value="rules">Regras</TabsTrigger>
          <TabsTrigger value="notifications">Notificações</TabsTrigger>
        </TabsList>
        
        <TabsContent value="rules" className="mt-6">
          <CashbackRules />
        </TabsContent>
        
        <TabsContent value="notifications" className="mt-6">
          <AutomatedMessages isModuleEnabled={true} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Cashback;
